import { useState, useEffect } from "react"
import Accordion from "../../components/accordion/accordion"
import Footer from "../footer/footer"
import Header from "../header/header"
import { getTermsAndCondition } from '../services';
import Skeleton from "../auth/component/skeleton";


const Faqs = () => {

    const [FAQs, setFAQs] = useState({})
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getFAQs()
    }, [])


    const getFAQs = async () => {
        try {
            const res = await getTermsAndCondition('faq');
            console.log(res.data);
            setFAQs(
                res.data.map(faq => ({
                    ...faq,
                    is_open: false
                }))
            );
        } catch (err) {
            console.error('Error fetching FAQs:', err);
        } finally {
            setLoading(false);
        }
    };

    const toggleAccordion = (id) => {
        setFAQs(prevFAQs =>
            prevFAQs.map(faq =>
                faq.id === id
                    ? { ...faq, is_open: !faq.is_open }
                    : { ...faq, is_open: false }
            )
        );
    };

    return (
        <>
            <div>
                <Header />
                <div className="bg-[#f1f1f1]">
                    <div className="container py-5">
                        <h4 className="font-xl mb-4 font-bold">
                            Frequently Asked Questions
                        </h4>
                        <div className="bg-[#ffffff] p-3">
                            {loading ? (
                                <>
                                    <div className="flex flex-col items-center bg-white shadow-md rounded-lg p-4">
                                        <Skeleton width='100%' />
                                    </div></>
                            ) : (
                                FAQs.map(faq => (
                                    <Accordion
                                        key={faq?.id}
                                        id={faq?.id}
                                        question={faq?.question}
                                        answer={faq?.answer}
                                        is_open={faq?.is_open}
                                        click={() => toggleAccordion(faq?.id)}
                                    />
                                ))
                            )}
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    )
}

export default Faqs